import { InternationalCurrency } from '@interfaces/common/internationalCurrencies';

export interface GlobalState {
  internationalCurrencies: InternationalCurrency[];
  showDebugInfo: boolean;
  pageFilterCompanyIds: string[] | null;
}

export const initialGlobalState: GlobalState = {
  internationalCurrencies: [],
  showDebugInfo: false,
  pageFilterCompanyIds: null,
};
